import { ValidationErrors, ValidatorFn } from '@angular/forms';

export function providerBalanceValidator(value: boolean): ValidatorFn {
    return (): ValidationErrors | null => {
        return { providerBalance: value };
    };
}
